export default {
  default: () => import("/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/layouts/default.vue").then(m => m.default || m),
  nofooter: () => import("/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/layouts/nofooter.vue").then(m => m.default || m),
  protocol: () => import("/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/layouts/protocol.vue").then(m => m.default || m)
}